const SOUND_ENABLED_KEY = 'notification_sound_enabled';

let audioContext = null;
let unlocked = false;

export function isNotificationSoundEnabled() {
	try {
		return localStorage.getItem(SOUND_ENABLED_KEY) !== 'false';
	} catch (e) {
		return true;
	}
}

export function setNotificationSoundEnabled(enabled) {
	try {
		localStorage.setItem(SOUND_ENABLED_KEY, enabled ? 'true' : 'false');
	} catch (e) {
		// Browser storage can be unavailable in private/restricted contexts.
	}
}

export function unlockNotificationSound() {
	if (unlocked || typeof window === 'undefined') {
		return;
	}
	const AudioContext = window.AudioContext || window.webkitAudioContext;
	if (!AudioContext) {
		return;
	}
	try {
		audioContext = audioContext || new AudioContext();
		if (audioContext.state === 'suspended') {
			audioContext.resume().catch(() => {});
		}
		unlocked = true;
	} catch (e) {
		unlocked = false;
	}
}

export function playNotificationSound() {
	if (!isNotificationSoundEnabled() || typeof window === 'undefined') {
		return;
	}
	const AudioContext = window.AudioContext || window.webkitAudioContext;
	if (!AudioContext) {
		return;
	}

	try {
		audioContext = audioContext || new AudioContext();
		if (audioContext.state === 'suspended') {
			audioContext.resume().catch(() => {});
			if (audioContext.state === 'suspended') {
				return;
			}
		}

		const now = audioContext.currentTime;
		const gain = audioContext.createGain();
		gain.gain.setValueAtTime(0.0001, now);
		gain.gain.exponentialRampToValueAtTime(0.08, now + 0.02);
		gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);
		gain.connect(audioContext.destination);

		const oscillator = audioContext.createOscillator();
		oscillator.type = 'sine';
		oscillator.frequency.setValueAtTime(740, now);
		oscillator.frequency.setValueAtTime(980, now + 0.08);
		oscillator.connect(gain);
		oscillator.start(now);
		oscillator.stop(now + 0.24);
	} catch (e) {
		// Browser autoplay/audio policies are best-effort; notification still works without sound.
	}
}
